import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

import { JobTypePickerComponent } from './job-type-picker.component';

@NgModule({
    declarations: [JobTypePickerComponent],
    imports: [
        CommonModule,
        FormsModule,
        OverlayModule,
    ],
    exports: [JobTypePickerComponent],
})
export class JobTypePickerModule {}
